import React from "react";
import {ModalProps} from "../Modal";
import styled from "styled-components";


export const NetworkErrModel: React.FC<ModalProps> = ({onDismiss}) => {
    return (
        <ErrTis>
            Please switch to Ethereum Mainnet network!
        </ErrTis>
    )
};


const ErrTis = styled.div`
color:#7688B7;
    background: #1E2D56;
    height: 50px;
z-index: 200;
text-align: center;
    line-height: 50px;
    border-radius: 5px;
    padding: 0 50px;
`;
